import { type App } from 'vue'
import { directives } from './directives'
import { permission } from './permission'

/** 挂载自定义指令 */
export function loadDirectives(app: App) {
  app.directive('permission', permission).directive('dateFormat', directives)
}
